import axios from '@/config/axiosConfig';

export const registerBroker = (data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();

            return axios.post('/broker-login/add-broker-to-customer-company',
                data,
                { params: {
                    userId: auth?.user?.id,
                    customerId: auth?.customer?.id,
                    companyId: auth?.company?.id
                }
            }).then( async (response) => {
                return response;
            }).catch((error) => {
                console.error(error);
                console.log('<<error--', error.messege, error.response?.data?.error);
                throw new Error(error.response?.data?.error || error.messege);
            });
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
};